// extracted by mini-css-extract-plugin
module.exports = {"sectionFlightPolicies":"style-module--sectionFlightPolicies--4V3v6"};